import { render, staticRenderFns } from "./DashboardWidgetMetrics.vue?vue&type=template&id=1cd9d8a2&scoped=true&"
import script from "./DashboardWidgetMetrics.vue?vue&type=script&lang=ts&"
export * from "./DashboardWidgetMetrics.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardWidgetMetrics.vue?vue&type=style&index=0&id=1cd9d8a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9d8a2",
  null
  
)

export default component.exports